import { useState } from "react";
import React, { Component } from "react";

export class Navigation extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
        <div className='container'>
          <div className='navbar-header'>
            <button
              type='button'
              className='navbar-toggle collapsed'
              data-toggle='collapse'
              data-target='#bs-example-navbar-collapse-1'
            >
              {' '}
              <span className='sr-only'>Toggle navigation</span>{' '}
              <span className='icon-bar'></span>{' '}
              <span className='icon-bar'></span>{' '}
              <span className='icon-bar'></span>{' '}
            </button>
            <a className='navbar-brand page-scroll' href='#page-top'>
              Pizza Mafia Pals
            </a>{' '}
          </div>
  
          <div
            className="collapse navbar-collapse"
            id='bs-example-navbar-collapse-1'
          >
            <ul className='nav navbar-nav navbar-right'>
              <li>
                <a href='#about' className='page-scroll' data-toggle='collapse'
              data-target='#bs-example-navbar-collapse-1'>
                  About
                </a>
              </li>
              <li>
                <a href='#howshare' className='page-scroll' data-toggle='collapse'
              data-target='#bs-example-navbar-collapse-1'>
                  How Share
                </a>
              </li>
              <li>
                <a href='#mint' className='page-scroll' data-toggle='collapse'
              data-target='#bs-example-navbar-collapse-1'>
                  Mint
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    )
  }
}